import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Strumenti } from '../models/models/pages/strumenti';


@Injectable({
    providedIn: 'root'
})
export class StrumentiService {
    private baseUrl = `${environment.baseApiUrl}/strumento-rilevatore`;


    constructor(private http: HttpClient) { }

    list(): Observable<Strumenti[]> {
        return this.http.get<Strumenti[]>(this.baseUrl);
    }
}
